import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import TableComponent from "../../components/TableComponent";
import { ENUM_ROUTES } from "../../RoutesEnum";
import { useLazyGetDiscountDetailQuery } from "../../services/discount";
import { showError } from "../../constants/toasts";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

const DiscountDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [valueTabs, setValueTabs] = React.useState(0);
  const [DiscountDetails] = useLazyGetDiscountDetailQuery();
  const [DiscountData, setDiscountData] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const getDataByIdList = async () => {
    try {
      setLoading(true);
      if (!id) return;
      const response = await DiscountDetails({ id }).unwrap();
      if (response.statusCode === 200) {
        setDiscountData(response.data);
       
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      showError(error?.message || error?.data?.message);
    }
  };


  useEffect(() => {
    if (id) {
      getDataByIdList();
    }
  }, [id]);

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const usageRows = [
    {
      id: 1,
      type: "Venue",
      name: "Grand Hall",
      startDate: "2025-07-01",
      usageCount: 15,
      status: "Active",
    },
    {
      id: 2,
      type: "Storage",
      name: "Safe Locker",
      startDate: "2025-07-03",
      usageCount: 8,
      status: "Expired",
    },
  ];

  const usageColumns = [
    { field: "type", headerName: "Type", flex: 1, minWidth: 100 },
    { field: "name", headerName: "Venue/Storage", flex: 1, minWidth: 150 },
    { field: "startDate", headerName: "Start Date", flex: 1, minWidth: 130 },
    { field: "usageCount", headerName: "Used Times", flex: 1, minWidth: 130 },
    { field: "status", headerName: "Status", flex: 1, minWidth: 100 },
  ];

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Coupon Details</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
          <span
            onClick={() => navigate(ENUM_ROUTES.DISCOUNT_COUPON_MANAGEMENT)}
          >
            Discount & Coupon Management
          </span>{" "}
          - Coupon Details
        </p>
      </div>

      <Box className="custom_tabs1" sx={{ width: "100%" }}>
        <Tabs
          value={valueTabs}
          onChange={handleChangeTabs}
          className="custom_tabs_links"
        >
          <Tab label="General Details" {...a11yProps(0)} />
          <Tab label="Usage History" {...a11yProps(1)} />
        </Tabs>
      </Box>

      <div style={{ marginTop: 20 }} />

      <CustomTabPanel value={valueTabs} index={0}>
        <div className="cards view_page">
          <div className="section_title">
            <h2>Coupon Information</h2>
          </div>
          <div className="gap_p">
            <div className="w_33">
              <h6>Offer Title</h6>
              <p>{DiscountData?.name || "N/A"}</p>
            </div>
            <div className="w_33">
              <h6>Discount Type</h6>
              <p>{DiscountData?.discountType || "N/A"}</p>
            </div>

            <div className="w_33">
              <h6>Min. Bookings Required</h6>
              <p>{DiscountData?.minBookingAmount || "N/A"}</p>
            </div>
            <div className="w_33">
              <h6>Valid From</h6>
              <p>
                {DiscountData?.startDate
                  ? new Date(DiscountData.startDate).toLocaleDateString()
                  : "N/A"}
              </p>
            </div>
            <div className="w_33">
              <h6>Valid Till</h6>
              <p>
                {DiscountData?.endDate
                  ? new Date(DiscountData.endDate).toLocaleDateString()
                  : "N/A"}
              </p>
            </div>
            <div className="w_33">
              <h6>Applicable Venues/Storages</h6>
              <p>
                {Array.isArray(DiscountData?.venueStorageId) &&
                DiscountData?.venueStorageId?.length
                  ? DiscountData.venueStorageId
                      .map((item: any) => item?.name)
                      .filter(Boolean)
                      .join(", ")
                  : "N/A"}
              </p>
            </div>
            <div className="w_33">
              <h6>Coupon Code</h6>
              <p>{DiscountData?.couponCode || "N/A"}</p>
            </div>
            <div className="w_33">
              <h6>Status</h6>
              <p>{DiscountData?.isActive ? "Active" : "Inactive"}</p>
            </div>
          </div>
        </div>
      </CustomTabPanel>

      <CustomTabPanel value={valueTabs} index={1}>
        <div className="cards">
          <TableComponent columns={usageColumns} rows={usageRows} />
        </div>
      </CustomTabPanel>
    </MainContainer>
  );
};

export default DiscountDetails;
